import i18n from '@/utils/i18n';
import React, { useEffect } from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { EmptyState, Icons, Spinner, View } from '@usepepper/sprout-kit-ui';
import { FinanceHubShellTemplate } from '@finance-hub/templates/finance-hub-shell-template';
import { FinanceHubTabParams } from '@/navigators/types';
import { navigateToFinanceHubRoute } from '@finance-hub/finance-hub-route-config';
import {
  NavigationProp,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import { useFinanceHubSidebarNavItemsLoader } from '@finance-hub/containers/sidebar/blocs/loaders/use-finance-hub-sidebar-nav-items-loader';

export const FinanceHubHomeScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp<FinanceHubTabParams>>();
  const isFocused = useIsFocused();
  const { loading, navItems } = useFinanceHubSidebarNavItemsLoader();

  useEffect(() => {
    const first = navItems[0];
    if (!isFocused || loading || !first) {
      return;
    }

    navigateToFinanceHubRoute(navigation, first.route, first.params);
  }, [isFocused, loading, navigation, navItems]);

  return (
    <FinanceHubShellTemplate>
      {loading ? (
        <View alignItems="center" flex={1} justifyContent="center">
          <Spinner size="large" />
        </View>
      ) : null}
      {!loading && navItems.length === 0 ? (
        <AppPageLayout scroll={false}>
          <EmptyState
            description={i18n.t('finance_hub.not_found.description')}
            icon={<Icons.AlertTriangle color="$iconPrimary" />}
            title={i18n.t('finance_hub.not_found.title')}
          />
        </AppPageLayout>
      ) : null}
    </FinanceHubShellTemplate>
  );
};
